import React, { useState, useEffect } from 'react';
import { Box, Button, Input, Typography, makeStyles } from '@material-ui/core';
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";
import { ReactComponent as CertificateBadge } from "../../../src/assets/images/certificatebadge.svg";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useSearchQuery } from '../../services/SearchQueryContext';
import NotFound from '../../pages/NotFound';
import { ReactComponent as SearchIcon } from "../../assets/images/search.svg";
import { ReactComponent as CrossIcon } from "../../assets/images/close.svg";
import CHeaderBarContent from '../common/Header/CHeaderBarContent';
import { certificateListAction } from 'examsbook-react-sdk/actions/certificateAddResponse';
import CommonButton from '../../constants/CommonButton';
import { useTheme } from '../../constants/themeProvider';
import { useCertificateDownload } from 'examsbook-react-sdk/custom-hooks';

function stripHtml(html) {
  let tmp = document.createElement("p");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText;
}

function CertificateListView() {
  const t = useTranslations();
  const dispatch = useDispatch();
  const { setNewFlag, searchQuery, setSearchQuery } = useSearchQuery();
  const user = useSelector((state) => state.user);
  const userName = user?.user?.name ? user?.user?.name : user?.name;
  const [certificateData, setCertificateData] = useState('')
  const [showComponent, setShowComponent] = useState(false);
  const theme = useTheme();
  const isFirefox = typeof InstallTrigger !== 'undefined';
  const classes = useStyles(isFirefox);
  const { handleDownloadCertificate } = useCertificateDownload({userName});

  useEffect(() => {
    dispatch(certificateListAction()).then((res) => {
      if (res?.data?.length) {
        setCertificateData(res?.data)
      }
    });
  }, []);

  const lowerSearchQuery = searchQuery.toLowerCase().trim();
  const filteredUserCourses =
    certificateData?.length &&
    certificateData.filter((data, index) => {
      const title = data?.courseId?.name
      const description = data?.courseId?.description;
      const descriptionText = stripHtml(description).toLowerCase();
      const lowerTitle = title?.toLowerCase();
      return (
        lowerTitle?.includes(lowerSearchQuery) ||
        descriptionText?.includes(lowerSearchQuery)
      );
    });
  const coursesToDisplay =
    searchQuery && searchQuery.trim() !== ""
      ? filteredUserCourses
      : certificateData;

  useEffect(() => {
    setNewFlag(true);
    return () => setNewFlag(false);
  }, []);

  function clearField(searchQuery) {
    if (searchQuery.length) setSearchQuery("");
  }

  useEffect(() => {
    setSearchQuery('')
    return setSearchQuery('');
  }, []);

  useEffect(() => {
    dispatch(certificateListAction()).then((res) => {
      setCertificateData(res.data)
    });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowComponent(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box className='container-div'>
      <CHeaderBarContent />
      <Box className="course-search-box">
        <Input
          className="inner-search-box"
          style={{ border: "none" }}
          type="text"
          placeholder={t('Search')}
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
        />
        <Box className="course-search-img-box">
          {searchQuery.length ? (
            <Button
              onClick={() => clearField(searchQuery)}
              style={{ border: "none" }}
            >
              <CrossIcon className="cross-icon" alt="Cross Icon" />
            </Button>
          ) : (
            <SearchIcon className="search-icon" alt="Search Icon" />
          )}
        </Box>
      </Box>
      <Box className="card-list-div">
        {coursesToDisplay && coursesToDisplay?.length ?
          <Box className='certificates-container'>
            {coursesToDisplay?.length && coursesToDisplay?.sort((a, b) => new Date(b?.completedOn) - new Date(a?.completedOn)).map((data, index) => (
              <Box key={index} className='certificate-card'>
                <Box className='content-container'>
                    <CertificateBadge alt="certificateImage" />
                  <Box className='certificate-name'>
                    <Typography variant="inherit" className="certificate-desc">{data?.courseId?.name}</Typography>
                  </Box>
                  <Box className='certificate-description' dangerouslySetInnerHTML={{ __html: data?.courseId?.description }}></Box>
                  <Box style={{marginTop: '12px'}}>
                  <Typography variant="inherit" className='certificate-score' style={{color: theme?.primaryColor}}>{t('Your Score')}</Typography>
                  <Typography variant="inherit" className='score' style={{color: theme?.primaryColor}}>{`${data?.score}/${data?.mark}`}</Typography>
                  <Typography variant="inherit" style={{ color: theme?.primaryColor, fontSize: "15px" }}> &#8226;</Typography>
                  <Typography variant="inherit" className='certificate-completion-date' style={{color: theme?.primaryColor}}>
                  {t('Completion Date')}
                  </Typography>
                  <Typography variant="inherit" className='completion-date' style={{color: theme?.primaryColor}}>{moment(data?.completedOn).format("DD MMM YYYY")}</Typography>
                  </Box>
                </Box>
                <Box style={{display: 'flex', justifyContent: 'center'}}>
                  <CommonButton onClick={() => handleDownloadCertificate(data?.courseId?.name, data?.completedOn)} title={t('Download')} classStyleHeading={classes.downloadButton} classStyleText={classes.downloadButtonText}/>
                </Box>
              </Box>
            ))}
          </Box>
          : showComponent &&
          <>{<Box className={classes.centerAlign}><NotFound /></Box>}</>
        }
      </Box>
    </Box>
  );
}
const useStyles = makeStyles(() => ({
  centerAlign: isFirefox => ({
    textAlign: isFirefox ? '-moz-center' : '-webkit-center',
  }),
  downloadButton: {
    border: 'none',
    margin: '10px 15px 10px 15px',
    display: 'flex',
    padding: '7px 27px',
    alignItems: 'center',
    cursor: 'pointer',
    '&:hover': {
      background: '#0c3450e0 !important'
    },
    '@media (max-width: 767px)': {
      width: '100%'
    }
  },
  downloadButtonText: {
    fontWeight: '600',
    display: 'block',
    color: '#ffffff',
    alignItems: 'center',
    fontSize: '14px',
    textTransform: 'capitalize'
  },
  courseBottomRight: {
    position: 'absolute',
    top: '10px',
    right: '-46px',
    textAlign: 'center',
    transform: 'rotate(45deg)',
    width: '139px',
    zIndex: '0'
  },
}));
export default CertificateListView;